import { appSettings } from "@/appSettings";
import BaseStoreBuilder from "@/store/base/BaseStoreBuilder";

const raceTeams = new BaseStoreBuilder({
    baseURL: appSettings.BaseUrl,
    entityName: "raceTeam"
})
    .getEntitiesList()
    .build();

export default raceTeams;